import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Element, Text } from "legacy/components/shared/base"

interface OwnProps {
  amountPerPage: number
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  totalItems: number
}

export type PageControlProps = OwnProps

const PageControls: React.FC<PageControlProps> = ({
  amountPerPage,
  page,
  setPage,
  totalItems,
}): React.ReactElement | null => {
  useStaticQuery(graphql`
    query pageControls($language: String! = "en") {
      locales: allLocale(
        filter: { ns: { in: ["shared"] }, language: { eq: $language } }
      ) {
        edges {
          node {
            ns
            data
            language
          }
        }
      }
    }
  `)
  const { t } = useTranslation("shared", {
    keyPrefix: "pagination",
  })

  const shouldDisablePrevious = page === 1
  const shouldDisableNext = totalItems < page * amountPerPage

  return (
    <Element display="flex">
      <Element
        as="button"
        color="teal"
        cursor={shouldDisablePrevious ? "not-allowed" : "pointer"}
        fontSize="text.body"
        onClick={() => setPage(shouldDisablePrevious ? page : page - 1)}
        opacity={shouldDisablePrevious ? ".25" : "1"}
      >
        <Text as="span" color="navy" fontSize="26" verticalAlign="middle">
          &lsaquo;{" "}
        </Text>
        {t("newer")}
      </Element>
      <Element
        as="button"
        color="teal"
        cursor={shouldDisableNext ? "not-allowed" : "pointer"}
        fontSize="text.body"
        marginLeft="auto"
        onClick={() => setPage(shouldDisableNext ? page : page + 1)}
        opacity={shouldDisableNext ? ".25" : "1"}
      >
        {t("older")}
        <Text as="span" color="navy" fontSize="26" verticalAlign="middle">
          {" "}
          &rsaquo;
        </Text>
      </Element>
    </Element>
  )
}

export default PageControls
